import type { CustomNode, CustomEdge } from '@src/components/custom-nodes/types';

export const getNearestNodeByType = (nodes: CustomNode[], edges: CustomEdge[], node: CustomNode, type: string) => {
  function findClosestNodeByType(type: string, currentNode: CustomNode) {
    const edgeWithCurrentNodeAsSource = edges.find((edge) => edge.source === currentNode.id);
    const targetNode = nodes.find((node) => node.id === edgeWithCurrentNodeAsSource?.target);


    if (targetNode?.type === type && targetNode?.branchId === node?.branchId) {
      return targetNode;
    } else if (targetNode) {
      return findClosestNodeByType(type, targetNode);
    }
  }

  return findClosestNodeByType(type, node);
}
